import BasicModel from '../basic/BasicModel'
export default {
    saveObdConfig(vm, params, listener){
        let action = 'obdConfig/saveObdConfig.action'
        BasicModel.post(vm, action, params, listener)
    },
    updateObdConfig(vm, params, listener){
        let action = 'obdConfig/updateObdConfig.action'
        BasicModel.get(vm, action, params, listener)
    },
    selectObdConfig(vm,params,listener){
        let action = 'obdConfig/selectObdConfig.action'
        BasicModel.get(vm, action, params, listener)
    }
}
